import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import Dashboard from 'portal/src/components/common/Dashboard';
import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';

import { RouteDefinition } from '../routeGenerator';

export const electricRouteDefinitions: RouteDefinition[] = [
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_ELECTRIC.USAGE} />
    ),
    name: 'Aggregated Usage',
    path: NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.USAGE,
    description: 'Analyze electric usage by selectable time periods',
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_ELECTRIC.MAP} />
    ),
    name: 'Usage Map',
    path: NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.MAP,
    description: 'Review electric usage by site location',
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_ELECTRIC.HEATMAP}
      />
    ),
    name: 'Electric Heatmap',
    path: NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.HEATMAP,
    description: 'Analyze electric usage over time',
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_ELECTRIC.METRICS}
      />
    ),
    name: 'Demand Metrics',
    path: NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.METRICS,
    description: 'Review key metrics about electric demand points',
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_ELECTRIC.TRENDS}
      />
    ),
    name: 'Demand Trends',
    path: NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.TRENDS,
    description: 'Analyze 15-minute electric demand trends',
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_ELECTRIC.PROFILES}
      />
    ),
    name: 'Demand Profiles',
    path: NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.PROFILES,
    description: 'Analyze electric demand load profiles by time of day',
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_ELECTRIC.POINTS}
      />
    ),
    name: 'All Electric Points',
    path: NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.POINTS,
    description: 'Analyze trends for all available electric points',
  },
];
